// src/api/objectiveTrials/endpoints.ts
// Essais d'objectifs (tc_embed_be, 0032, admin seulement).
export const OBJECTIVE_TRIALS_ENDPOINTS = {
  /** Liste (50 derniers) ; POST = lancer (202, 409 si un essai d'objectifs est actif). */
  BASE: "/v1/objectives/trials",
  /** Leçons, réglage effectif avec son origine, coût estimé, coût des faits par objectif. */
  ESTIMATE: "/v1/objectives/trials/estimate",
  /** Détail (GET) ; jeter (DELETE). */
  DETAIL: (id: string) => `/v1/objectives/trials/${id}`,
  /** Écrire les brouillons encore valables, faits chaînés (202, en arrière-plan). */
  APPLY: (id: string) => `/v1/objectives/trials/${id}/apply`,
} as const;
